import AffiliateList from './containers/AffiliateList.js';

export default AffiliateList;
